import angular from 'angular';

import SearchController from './search.controller';
import SearchService from './search.service';

export default angular.module('app.search', [])
    .controller('SearchController', SearchController)
    .service('SearchService', SearchService)
    .run(() => {


    })
    .name;



// WEBPACK FOOTER //
// ./src/app/search/index.js